const Ticker = () => {
  const parts = [
    "Save the Date",
    "04 · 06 · 2027",
    "Granada · España",
    "Cortijo de Enmedio",
    "Macarena & Virginia",
  ];
  const strip = parts.join("   /   ") + "   /   ";

  return (
    <div
      data-testid="ticker-marquee"
      className="border-t border-[#c9c3b3] py-3 overflow-hidden"
      aria-hidden="true"
    >
      <div className="marquee flex whitespace-nowrap">
        {Array.from({ length: 6 }).map((_, i) => (
          <span
            key={i}
            className="mx-2 font-mono text-[11px] uppercase tracking-[0.24em]"
            style={{ color: "#891613" }}
          >
            {strip}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Ticker;
